import React, { useEffect, useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Box, Link, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClaimDetails } from '../../../redux/claims/actions';
import ImageBanner from './ImageBanner';
import Loader from './Loader';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import {
  getSelfBenefitsExplanation,
  getDependentBenefitsExplanation,
  setClaimBenefitsClean
} from '../../../redux/claims/actions';
import { analyticsTrackClickEvent } from '../../../utils/analytics/analytics-utils';
import Tooltip from '@mui/material/Tooltip';
import {useNavigate, useLocation} from 'react-router-dom';
import Label from '../type/Label';
import PropTypes from 'prop-types';

const ClaimInDetail = (props) => {
  const dispatch = useDispatch();
const navigate = useNavigate();
  const { id } = useParams();
const location = useLocation();

const memberAccountHeader = props.memberAccountHeader || location.state?.memberAccountHeader;

  usePageTitle('Claims');
  useEffect(() => {
    if (memberAccountHeader) {
    dispatch(getClaimDetails(id, localStorage.getItem('tenantHandle'), memberAccountHeader));
    }
  }, [id, memberAccountHeader, dispatch]);
  const claim = useSelector(state => state?.claims?.claimDetails);
  const claimBenefits = useSelector(state => state?.claims?.claimBenefits);
  const claimDetailsError = useSelector(
    state => state?.claims?.claimDetailsError
  );
  const [noEOB, setNoEOB] = useState('');
  const [eobSelected, setEobSelected] = useState(false);

  useEffect(() => {
    dispatch(setClaimBenefitsClean());
    if (claimBenefits && Object.keys(claimBenefits).length > 0) {
      setNoEOB('');
      const blob = new Blob([claimBenefits], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setEobSelected(false);
    } else if (
      eobSelected &&
      claimBenefits &&
      Object.keys(claimBenefits).length == 0
    ) {
      setEobSelected(false);
      setNoEOB(
        'Explanation of Benefits not yet available. Please check back soon.'
      );
    }
  }, [claimBenefits]);
  const handleClaimBenefits = (claimNumber, memberSFX, memberID) => {
    setEobSelected(true);
    if (memberSFX === '0') {
      dispatch(
        getSelfBenefitsExplanation(
          claimNumber,
          localStorage.getItem('tenantHandle')
        )
      );
    } else
      dispatch(
        getDependentBenefitsExplanation(
          claimNumber,
          memberID,
          localStorage.getItem('tenantHandle')
        )
      );
    dispatch(setClaimBenefitsClean());
  };
  return (
    <>
      {claim ? (
        claim.totalYouOwe && (
          <>
            <ImageBanner title={<Label id='claimsLink'/>} banner="homePageBanner"></ImageBanner>
            <div className="ClaimInfo">
            <span className='backtoClaims' onClick={() => navigate(-1)}><Label id='backToClaims'/></span>
             
              <div className="claimsDetiails-Header">
                <p className="claimsDetails-title">
                  <Label id='estimatedCostText'/>{claim.totalYouOwe}
                </p>
                <p className="claimsDetails-subtitle">
                  <Label id='claimDetailFeature'/> #
                  {claim.claimNumber}.
                </p>
                <p className="claimsDetails-mobile-title">
                  Your visit was with
                </p>
              </div>
              <div className="claims-details-body">
                <div className="page-layout">
                  {/* Left Side */}
                  <div className="claim-detail-left-side">
                    <div className="section" id='claim-details-box'>
                      <Box className="box">
                        <div className="claim-boxes">
                          <h2 className="claims-details-body-subtitles">
                            <Label id='costBrakeDownText'/>
                          </h2>

                          <div className="cost-item">
                            <Tooltip
                              title="The amount billed to your insurance by the provider or facility."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='totalChargeText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='totalChargeText'/>
                              </Typography>
                            <Typography className='cost-item-value'>${claim.totalCharge}</Typography>
                          </div>
                          <div className="cost-item">
                            <Tooltip
                              title="The difference between the amount billed and the amount the provider has agreed to accept as payment."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='discountText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='discountText'/>
                              </Typography>
                            <Typography className='cost-item-value'>-${claim.totalDiscount}</Typography>
                          </div>
                          <div className="cost-item">
                            <Tooltip
                              title="The amount your plan paid for covered health care services."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='amountCoveredText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='amountCoveredText'/>
                              </Typography>
                            <Typography className='cost-item-value'>-${claim.totalAllowedAmt}</Typography>
                          </div>
                        </div>
                        <hr className="divider" />

                        {/* You Owe */}
                        <div className="you-owe">
                        <Tooltip
                              title="A specific fixed amount a member must pay at the time and place services are rendered. Copays may be different amount for different services, and a deductible may need to be met before copay rates apply."
                              placement="top"
                            >
                          <Typography className="cost-item-heading">
                          <Label id="YouMayOwe" />
                          </Typography>
                          </Tooltip>
                          <Typography className="cost-item-mobile-heading you-owe-me">
                          <Label id="YouMayOwe" />
                          </Typography>
                          <Typography className='cost-item-value'>${claim.totalYouOwe}</Typography>
                        </div>
                      </Box>
                    </div>
                    <div className="section">
                      <Box className="box">
                        <div className="claim-boxes">
                          <h2 className="claims-details-body-subtitles">
                            <Label id="contributionText"/>
                          </h2>

                          <div className="cost-item">
                            <Tooltip
                              title="A specific fixed amount a member must pay at the time and place services are rendered. Copays may be different amount for different services, and a deductible may need to be met before copay rates apply."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='copayText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='copayText'/>
                              </Typography>
                            <Typography className='cost-item-value'>${claim.coPayAmt}</Typography>
                          </div>
                          <div className="cost-item">
                            <Tooltip
                              title="The share of the cost of covered services for which the member is responsible after the applicable annual deductible is met. Coinsurance payments accumulate throughout the calendar year until the individual or family out-of-pocket max is reached."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='coinsuranceText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='coinsuranceText'/>
                              </Typography>
                            <Typography className='cost-item-value'>${claim.totalCoinsuranceAmount}</Typography>
                          </div>
                          <div className="cost-item">
                            <Tooltip
                              title="A service or expense that is not covered under your plan."
                              placement="top"
                            >
                              <Typography className="cost-item-heading">
                                <Label id='amountNotCoveredText'/>
                              </Typography>
                            </Tooltip>
                            <Typography className="cost-item-mobile-heading">
                                <Label id='amountNotCoveredText'/>
                              </Typography>
                            <Typography className='cost-item-value'>${claim.totalNotCoveredAmount}</Typography>
                          </div>
                        </div>
                      </Box>
                    </div>
                  </div>

                  {/* Right Side */}
                  <div className="claim-detail-right-side">
                    <div className="claim-detail-section">
                      <Box className="box">
                        <div className="doctor-details">
                          {claim.providerName && (
                            <div className="doctor-header">
                              <div className="avatar">
                                {claim.providerName.charAt(0)}
                              </div>
                              <div className="doctor-info">
                                <div className="doctor-name">
                                  {claim.providerName}
                                </div>
                              </div>
                              
               
                            </div>
                          )}
                          <hr className="divider" />
                          <div className="doctor-content">
               
                            {claim.claimStatusDescription && (
                              <div className="content-section">
                                <p>
                                  <Label id='claimStatus'/>
                                </p>
                                <p className="claim-doctor-details">
                                  {claim.claimStatusDescription.split(';')[0]}
                                </p>
                              </div>
                            )}

                            {claim.firstName && (
                              <div className="content-section">
                                <p><Label id='patientText'></Label></p>
                                <p className="claim-doctor-details">
                                  {`${claim.firstName} ${claim.lastName}`}
                                </p>
                              </div>
                            )}

                            {claim.lines[0].serviceDateFrom && (
                              <div className="content-section">
                                <p><Label id="DateofService"/></p>
                                <p className="claim-doctor-details">
                                  {claim.lines[0].serviceDateFrom}
                                </p>
                              </div>
                            )}

                            {claim.claimNumber && (
                              <div className="content-section">
                                <p><Label id='claimIdText'/></p>
                                <p className="claim-doctor-details">
                                  {claim.claimNumber}
                                </p>
                              </div>
                            )}
                          </div>

                          {claim.cptCode && (
                            <div className="content-section">
                              <p><Label id='serviceCodeText'/></p>
                              <p className="claim-doctor-details">
                                {claim.cptCode}
                              </p>
                            </div>
                          )}

                          {claim.currentProcedureDescription && (
                            <div className="content-section">
                              <p className="claim-procedure-desc">
                                <Label id='serviceDescriptionText'/>
                              </p>
                              <p className="claim-doctor-details claim-procedure-desc">
                                {claim.currentProcedureDescription}
                              </p>
                            </div>
                          )}

                          <hr className="divider" />
                          <div className="content-section" id='claim-benefits-explanation-box'>
                            <div className="claim-benefits-explanation">
                              <p className="claim-benefits-title">
                                <Label id='explanationOfBenText'/>
                              </p>
                              <p className="claim-benefits-doc-view">
                                <Link
                                  to="#"
                                  onClick={e => {
                                    e.preventDefault();
                                    handleClaimBenefits(
                                      claim?.claimNumber,
                                      claim?.memberSFX,
                                      claim?.memberID
                                    );
                                    analyticsTrackClickEvent('claim_benifits', {
                                      eventCategory: 'Claim Benefits Pathing'
                                    });
                                  }}
                                >
                                  <Label id='clickToView'/>
                                </Link>
                              </p>
                            </div>
                            <div className="claim-benefits-doc-desc">
                              <StickyNote2Icon
                                onClick={e => {
                                  e.preventDefault();
                                  handleClaimBenefits(
                                    claim?.claimNumber,
                                    claim?.memberSFX,
                                    claim?.memberID
                                  );
                                  analyticsTrackClickEvent('claim_benifits', {
                                    eventCategory: 'Claim Benefits Pathing'
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="claim-benefits-eob">{noEOB}</div>
                        </div>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      ) : (
        <Loader />
      )}
      {claimDetailsError && (
        <div className="ClaimInfo">
          <Typography variant="h6" color="red">
            {claimDetailsError}
          </Typography>
        </div>
      )}
    </>
  );
};

ClaimInDetail.propTypes = {
  memberAccountHeader: PropTypes.string
};

export default ClaimInDetail;
